import React, { useState, useEffect } from 'react'
import { Container, Grid, Button, Box, TextField, Typography, Autocomplete, Stack } from '@mui/material'
import makeStyles from "@mui/styles/makeStyles"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import AmplifierList from '../components/AmplifierList'
import { styled } from '@mui/material/styles'
import { Router } from '@mui/icons-material'
import RelatoryNameField from '../components/RelatoryNameField'
import format from 'date-fns/format'
import ptBR from 'date-fns/locale/pt-BR'
import Pagination from '@mui/material/Pagination'
import AmplifierStatusList from '../components/AmplifierStatusList'
import Calendar from '../components/Calendar'
import PdfViewer from '../providers/PdfViewer'
import Drawer from '../includes/Drawer'
import { ReactComponent as IconPDF } from '../assets/icons/icon_file_pdf.svg'

const useStyles = makeStyles({
    pageAmplifierRelatory: {
        minHeight: "100vh",
        paddingTop: "4rem"
    },
    buttonRegisterRelatory: {
        marginTop: '3rem',
        marginBottom: '3rem'
    },
})

const Item = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginTop: 8,
    width: '100%',
    border: '1px solid #E0E0E0',
    borderLeft: '3px solid #95A5A6',
    borderRadius: '4px',
    transition: 'all 0.15s ease-in-out',
    '&:hover': {
        borderLeft: '3px solid #6A5A7C',
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)'
    }
}));

const ItemHeader = styled('div')(({ theme }) => ({
    backgroundColor: '#5D4E6D',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: '#ECF0F1',
    height: '56px',
    width: '100%',
    borderRadius: '4px 4px 0 0',
    borderBottom: '2px solid #6A5A7C',
    fontWeight: 600
}));

export default function AmplifierStatusRelatory(props) {
    const classes = useStyles()
    const [nameList, setNameList] = useState([])
    const [status, setStatus] = useState([])
    const [ds, setDsList] = useState(["Todos"])
    const [groupList, setGroupList] = useState([])
    const [amplifiers, setAmplifiers] = useState([])
    const [result, setResult] = useState([])
    const [localList, setLocalList] = useState(["Todos"])
    const [amplifierId, setAmplifirId] = useState("")
    const [description, setDescription] = useState("")
    const [local, setLocal] = useState("")
    const [amplifierStatus, setAmplifierStatus] = useState(false)
    const [relatoryName, setRelatoryName] = useState("")
    const [menuItens, setMenuItens] = useState("")
    const [firstDate, setFirstDate] = useState(format(new Date(), 'MM/dd/yyyy'), { locale: ptBR })
    const [secondDate, setSecondtDate] = useState(format(new Date(), 'MM/dd/yyyy'), { locale: ptBR })
    const [page, setPage] = useState(1)
    const [pagination, setPagination] = useState({})
    const [show, setShow] = useState(false);

    const changeRelatoryName = (newName) => {
        setRelatoryName(newName)
    }

    const fetchGroups = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/group/all`, {
                method: 'POST',
                headers: {
                    "content-type": "application/json",
                    "Authorization": `Bearer ${props.token}`
                },
                body: JSON.stringify({
                    "serialNumber": props.serial,
                })
            });

            if (!response.ok) throw new Error("Não foi possível obter a lista de grupos");

            const data = await response.json();
            
            // Ordena os grupos numericamente
            const sortedGroups = data.sort((a, b) => {
                const groupNumberA = parseInt(a.vL_CADASTRO.slice(12), 10);
                const groupNumberB = parseInt(b.vL_CADASTRO.slice(12), 10);
                return groupNumberA - groupNumberB;
            });

            setGroupList(["Todos", "Não Mapeados", ...sortedGroups]);
        } catch (error) {
            console.error("Erro ao buscar grupos:", error);
        }
    }

    const getAll = async () => {
        props.setIsLoading(true);

        var response = await fetch(`${process.env.REACT_APP_URL}/amplifier/all`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            },
            body: JSON.stringify({
                "serialNumber": props.serial,
            })
        })

        var data = await response.json()

        setAmplifiers(data)

        var uniqueNames = Array.from(new Set(data.map(amplifier => amplifier.dS_NOME)))
            .map(dS_NOME => {
                return {
                    label: dS_NOME === null ? "Sem nome registrado" : dS_NOME
                }
            })

        setNameList(uniqueNames)

        var dressLow = Array.from(new Set(data.map(amplifier => amplifier.dS_DL)))
            .map(dS_DL => {
                return {
                    label: dS_DL.toUpperCase()
                }
            })

        setDsList(ds.concat(dressLow))

        var status = [
            {
                label: "online"
            },
            {
                label: "offline"
            }
        ]

        setStatus(status)

        var location = Array.from(new Set(data.map(amplifier => amplifier.dS_LOCALIZACAO)))
            .map((dS_LOCALIZACAO => {
                return {
                    label: dS_LOCALIZACAO === '' ? "Sem nome registrado" : dS_LOCALIZACAO
                }
            }))

        

        setLocalList(localList.concat(location))

        props.setIsLoading(false);
    }

    const gerarPdf = () => {

        if (local === '') {
            setLocal('Todos');
        }

        let actionUrl = `${process.env.REACT_APP_URL}/relatory/amplifier/status?pageNumber=1&pageSize=100&firstDate=${firstDate}&secondDate=${secondDate}&menuItens=${menuItens}&user=${props.user.name}${amplifierId === 'Todos' ? '' : '&dsDL=' + amplifierId}${local === 'Todos' ? '' : '&local=' + local}`;

        if (process.env.REACT_APP_MODE === "desktop") {
            PdfViewer.Download(actionUrl, "GET", props.token, "relatorio-status-amplificadores", props.setIsLoading);
        } else {
            PdfViewer.PrintAsync(actionUrl, "GET", props.token, props.setIsLoading);
        }
    }

    //const request = async () => {
    //    props.setIsLoading(true);

    //    if (local === '') {
    //        setLocal('Todos');
    //    }

    //    if (local === "Não Mapeados") {
    //        // Use os amplifiers já carregados ou faça um fetch se necessário
    //        const filtered = amplifiers.filter(a => a.dS_DH && a.dS_DH.endsWith("1"));
    //        setShow(true);
    //        setResult(filtered);
    //        props.setIsLoading(false);
    //        return;
    //    }

    //    fetch(`${process.env.REACT_APP_URL}/amplifier/status/relatory?pageNumber=1&pageSize=100&firstDate=${firstDate}&secondDate=${secondDate}&menuItens=${menuItens}&name${relatoryName}${amplifierId === 'Todos' ? '' : '&dsDL=' + amplifierId}${local === 'Todos' ? '' : '&local=' + local}`,
    //        {
    //            method: "GET",
    //            headers: {
    //                'Content-Type': 'application/json',
    //                'Accept': 'application/json',
    //                'Access-Control-Expose-Headers': '*',
    //                "Authorization": "Bearer " + props.token
    //            }
    //        })
    //        .then(response => (
    //            setPagination(JSON.parse(response.headers.get("X-Pagination"))),
    //            response.json()
    //        ))
    //        .then(data => {
    //            setShow(true);
    //            setResult({})
    //            setResult(data)
    //            props.setIsLoading(false);
    //        })
    //}
    const request = async () => {
        props.setIsLoading(true);

        if (local === '') {
            setLocal('Todos');
        }

        const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/status/relatory?pageNumber=1&pageSize=100&firstDate=${firstDate}&secondDate=${secondDate}&menuItens=${menuItens}&name${relatoryName}${amplifierId === 'Todos' ? '' : '&dsDL=' + amplifierId}${local === 'Todos' || local === 'Não Mapeados' ? '' : '&local=' + local}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Expose-Headers': '*',
                    "Authorization": "Bearer " + props.token
                }
            });
        setPagination(JSON.parse(response.headers.get("X-Pagination")));
        const data = await response.json();

        let filteredData = data;
        if (local === "Não Mapeados") {
            filteredData = data.filter(a => a.dS_DH && a.dS_DH.endsWith("1"));
        }
        console.log("LOCAL: ", local)
        console.log("DATA: ", data)
        console.log("FILTERED DATA: ", filteredData)
        setShow(true);
        setResult(filteredData);
        props.setIsLoading(false);
    }


    const pageChange = (event, value) => {
        props.setIsLoading(true);
        setPage(value)

        fetch(`${process.env.REACT_APP_URL}/amplifier/status/relatory?pageNumber=${value}&pageSize=100&firstDate=${firstDate}&secondDate=${secondDate}&menuItens=${menuItens}${ds === '' ? '' : '&dsDL=' + amplifierId}${local === '' ? '' : '&local=' + local}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Expose-Headers': '*',
                    "Authorization": "Bearer " + props.token
                }
            })
            .then(response => (
                setPagination(JSON.parse(response.headers.get("X-Pagination"))),
                response.json()
            ))
            .then(data => {
                setShow(true);
                setResult({})
                setResult(data)
                props.setIsLoading(false);
            })
    }

    useEffect(() => {
        setResult([])
        if (props.serial === undefined) {
            setMenuItens(Array.from(new Set(
                props.menuItens.map(item => {
                    return item.id_central;
                })
            )))
        } else {
            setMenuItens(props.serial)
        }
    }, [props.menuItens])

    useEffect(() => {
        getAll();
        fetchGroups();
    }, []);

    return (
        <div class="container" style={{ paddingTop: '1.5rem', paddingBottom: '2rem' }}>
            <center>
                <h3 class="mb-5">Relatório da Situação dos Amplificadores</h3>
            </center>

            <div class="filter">
                {/* <div class="filter__column filter__column--fw">
                    <RelatoryNameField changeRelatoryName={changeRelatoryName} />
                </div> */}
                <div class="filter__column">
                    <Calendar label={"Data Inicial"} setDate={setFirstDate} />
                </div>
                <div class="filter__column">
                    <Calendar label={"Data Final"} setDate={setSecondtDate} />
                </div>
                <div class="filter__column">
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={groupList}
                        defaultValue={"Todos"}
                        sx={{ width: "100%", mx: 'auto' }}
                        getOptionLabel={(option) => {
                            if (option === "Todos") return "Todos";
                            if (option === "Não Mapeados") return "Não Mapeados";
                            return `${option.vL_CADASTRO.slice(12)} - ${option.dS_LOCALIZACAO || 'Sem nome registrado'}`;
                        }}
                        onChange={(event, value) => {
                            if (value === "Todos" || !value) {
                                setLocal("");
                            } else if (value === "Não Mapeados") {
                                setLocal("Não Mapeados");
                            } else {
                                setLocal(value.vL_CADASTRO.slice(12));
                            }
                        }}
                        renderInput={(params) => <TextField {...params} label="Grupo" />}
                    />
                </div>
                <div class="filter__column">
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={ds}
                        defaultValue={"Todos"}
                        sx={{ width: "100%", mx: 'auto' }}
                        onChange={(event) => setAmplifirId(event.target.innerText === undefined ? "" : event.target.innerText)}
                        renderInput={(params) => <TextField {...params} label="ID" />}
                    />
                </div>
            </div>

            <div class="buttons-container buttons-container--right mb-5">
                <button type="button" class="button button--md button--primary" title="Buscar" onClick={request} disabled={props.isLoading}>
                    <span class="button__label">Buscar</span>
                </button>
                <button type="button" class="button button--transparent" title="Gerar PDF" onClick={gerarPdf} disabled={props.isLoading}>
                    <IconPDF className="button__icon df-i df-i-red df-i-2xl"/>
                </button>
            </div>

            {!!show &&
                <>
                    <Stack alignItems="center" spacing={3}>
                        <ItemHeader style={{"display": "flex", "alignItems": "center", "justifyContent": "center"}}>
                            <Grid alignItems="center" container spacing={3} style={{"display": "flex", "alignItems": "center", "justifyContent": "center", "marginTop": 0,"marginLeft": 0}}>
                                <Grid item key={2} xs={2} md={2} lg={2} style={{"display": "flex", "alignItems": "center", "justifyContent": "center", "paddingTop": "5px", "paddingBottom": "5px", "paddingLeft": 0}}>
                                    <Typography variant="delta">I.D.</Typography>
                                </Grid>

                                <Grid item key={3} xs={2} md={2} lg={2} style={{"display": "flex", "alignItems": "center", "justifyContent": "center", "paddingTop": "5px", "paddingBottom": "5px", "paddingLeft": 0}}>
                                    <Typography variant="delta">Local</Typography>
                                </Grid>

                                <Grid item key={4} xs={2} md={2} lg={2} style={{"display": "flex", "alignItems": "center", "justifyContent": "center", "paddingTop": "5px", "paddingBottom": "5px", "paddingLeft": 0}}>
                                    <Typography variant="delta">Grupo</Typography>
                                </Grid>

                                <Grid item key={5} xs={3} md={3} lg={3} style={{"display": "flex", "alignItems": "center", "justifyContent": "center", "paddingTop": "5px", "paddingBottom": "5px", "paddingLeft": 0}}>
                                    <Typography variant="delta">Status</Typography>
                                </Grid>

                                <Grid item key={6} xs={3} md={3} lg={3} style={{"display": "flex", "alignItems": "center", "justifyContent": "center", "paddingTop": "5px", "paddingBottom": "5px", "paddingLeft": 0}}>
                                    <Typography variant="delta">Data</Typography>
                                </Grid>
                            </Grid>
                        </ItemHeader>
                        {result.length > 0 ? result.map(row => {
                            return <Item item key={row.id} xs={12} md={12} lg={12} sx={{ backgroundColor: '#FFFFFFF' }}> <AmplifierStatusList key={row.dS_NUM_SERIE} amplifier={row} status={status} /> </Item>
                        }) : <Typography>Nenhum resultado encontrado!</Typography>}
                    </Stack>
                    <Container sx={{ p: 2 }}>
                        <Pagination
                            count={pagination.TotalPages}
                            onChange={pageChange}
                            page={page}
                        />
                    </Container>
                </>
            }
            {/* <Drawer drawerId='amplifier-status-relatory-pdf' className='drawer--bottom-full'>
                <Drawer.Header>
                    <h4>Relatório para impressão</h4>
                </Drawer.Header>
                <Drawer.Body></Drawer.Body>
            </Drawer> */}
        </div>
    )
}